import
http
    // { httpmock }
    from "./../shared/axios";
import { Lead_Track_Auth } from "../shared/ServiceCommonEndpoints";
class TrackService {
    funcTrackApp(payload) {
        const track = {
            data: {
                ...payload
            },
            action: "TrackHSToken",
            type: "Swift App"
        }
        return http.post(Lead_Track_Auth, track,
            {
                headers: {
                    "IDENTIFIER_1": localStorage.getItem("visitorID"),
                    "IDENTIFIER_2": payload.hsToken
                }
            }
        );
        // return httpmock.post("newcard-lead-track-auth", track);
    }
}
// eslint-disable-next-line
export default new TrackService();
